import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from 'antd';
import PropTypes from 'prop-types';
import { Panel, PopDeleteConfirm } from 'components/ui/index';
import TriggerActionsContent from './TriggerActionsContent';
import { addTrigger, delectTrigger } from '../../flow/action';

const defaultProps = {
  triggerSessions: [],
  triggerTypes: [],
};
const propTypes = {
  triggerSessions: PropTypes.array,
  triggerTypes: PropTypes.array,
  workFlowId: PropTypes.string.isRequired,
  addTrigger: PropTypes.func.isRequired,
  delectTrigger: PropTypes.func.isRequired,
  hadleSiderClose: PropTypes.func.isRequired,
};

const TriggerActions = ({
  triggerSessions,
  addTrigger,
  delectTrigger,
  triggerTypes,
  workFlowId,
  hadleSiderClose
}) => (
  <React.Fragment>
    <div className="text-right">
      <Button size="small" onClick={addTrigger}>
        <Icon className="font-sm" type="plus" />
        <FormattedMessage id="page.WorkFlow.addTrigger" />
      </Button>
    </div>
    {triggerSessions && triggerSessions.map(action => (
      <Panel
        key={action.sessionNum}
        panelClasses="mt-md"
        contentClasses="pl-xlg pr-xlg pt-lg pb-xlg"
        actionsRight={
          <PopDeleteConfirm
            placement="top"
            onConfirm={() => delectTrigger(action.sessionNum)}
          >
            <Icon type="close" className="cursor-pointer" />
          </PopDeleteConfirm>
        }
      >
        <TriggerActionsContent
          triggerTypes={triggerTypes}
          actionValue={action}
          workFlowId={workFlowId}
          hadleSiderClose={hadleSiderClose}
        />
      </Panel>
    ))}
  </React.Fragment>
);

TriggerActions.defaultProps = defaultProps;
TriggerActions.propTypes = propTypes;

const mapStateToProps = ({ global, setup }) => ({
  lang: global.language,
  triggerSessions: setup.workFlow.WorkFlowTrigger.triggerSessions,
  triggerTypes: setup.workFlow.metaData.triggerMeta.triggerTypes,
});
const mapDispatchToProps = {
  addTrigger,
  delectTrigger
};

export default connect(mapStateToProps, mapDispatchToProps)(TriggerActions);



// WEBPACK FOOTER //
// ./src/views/Setup/WorkFlow/components/TriggerActions/index.jsx